(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collab-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collab-tabs')) {
    class CollabTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab)));
        this.querySelector('[role="tablist"]').addEventListener('keydown', (e) => {
          const i = this.tabs.indexOf(document.activeElement);
          if (i < 0) return;
          let next = null;
          if (e.key === 'ArrowRight') next = this.tabs[(i + 1) % this.tabs.length];
          if (e.key === 'ArrowLeft') next = this.tabs[(i - 1 + this.tabs.length) % this.tabs.length];
          if (next) { e.preventDefault(); this.select(next); next.focus(); }
        });
        // En el editor: al seleccionar un bloque, mostrar su pestaña
        this._onBlockSelect = (e) => { if (this.tabs.includes(e.target)) this.select(e.target); };
        document.addEventListener('shopify:block:select', this._onBlockSelect);
      }
      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this._onBlockSelect);
      }
      select(tab) {
        this.tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          const panel = this.querySelector('#' + CSS.escape(t.getAttribute('aria-controls')));
          if (panel) panel.hidden = !on;
        });
        tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
    }
    customElements.define('collab-tabs', CollabTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
